<div class="layout-wrapper d-flex flex-column min-vh-100">
  <app-header></app-header>
  <div class="content-row d-flex flex-grow-1 h-100">
    <main class="main-content flex-grow-1 overflow-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>